import { Link } from "react-router-dom";
import estilos from "./NaoEncontrada.module.css";

function NaoEncontrada() {
    return (
        <div className={estilos.naoEncontrada}>
            <img src="./imagens/notFound.png" alt="Imagem da página não econtrada"/>
            <div>
                <h1>ERRO!</h1>
                <h2>PÁGINA NÃO ENCONTRADA</h2>
                <a>
                    <Link to="/personagens">Voltar</Link>
                </a>
            </div>
        </div>
    )
}

export default NaoEncontrada;